/* import Dashboard from "layouts/Dashboard/Dashboard.jsx";
var indexRoutes = [{ path: "/", name: "noticias", component: Dashboard }]; */

import Home from "../site/Home";
var indexRoutes = [{ path: "/", name: "Home", component: Home }];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx